import React from "react";
import "../MonopolyPrivacyPolicy/style.css";
import "./style.css";
import ContactSpin from "../SpinMasterPrivacyPolicy/ContactSpin";

const CrazyFoxPrivacyPolicy = () => {
  return (
    <div
      className="monopoly-policy-main crazy-fox"
      style={{ backgroundColor: "transparent" }}
    >
      <h1>Privacy Policy For Reward Links for Crazy Fox</h1>
      <p>
        <strong>Last updated: June 08, 2026</strong>
      </p>

      <p>
        This Privacy Policy describes Our policies and procedures on the
        collection, use, and disclosure of Your information when You use the{" "}
        <strong>Reward Links for Crazy Fox</strong> app (the "Application") and
        tells You about Your privacy rights and how the law protects You.
      </p>

      <h2>1. Information Collection and Use</h2>
      <p>
        For a better experience, while using our Service, we may require you to
        provide us with certain personally identifiable information. The
        information that we request will be retained by us and used as described
        in this privacy policy.
      </p>

      <h2>2. Third-Party Services and Tracking</h2>
      <p>
        Our app does use third-party services that may collect information used
        to identify you, provide analytics, send push notifications, and serve
        advertisements. Specifically, we use the following services:
      </p>
      <ul>
        <li>
          <strong>Google Analytics:</strong> We use Google Analytics to
          understand how users interact with our app. It collects data such as
          usage time, device model, operating system, and geographic location to
          help us improve user experience. Read their{" "}
          <a
            href="https://policies.google.com/privacy"
            target="_blank"
            rel="noreferrer"
          >
            Privacy Policy
          </a>
          .
        </li>
        <li>
          <strong>Firebase Cloud Messaging (FCM):</strong> We use FCM to send
          you push notifications regarding daily rewards and app updates. FCM
          may collect instance IDs to determine which devices to send messages
          to. Read more at{" "}
          <a
            href="https://firebase.google.com/support/privacy"
            target="_blank"
            rel="noreferrer"
          >
            Firebase Privacy
          </a>
          .
        </li>
        <li>
          <strong>AdMob (Google):</strong> We use AdMob to serve advertisements
          within the app. AdMob may use device identifiers, such as the Apple
          Advertising Identifier (IDFA), and cookies to serve personalized or
          non-personalized ads based on your interests and location. Read more
          at{" "}
          <a
            href="https://policies.google.com/technologies/ads"
            target="_blank"
            rel="noreferrer"
          >
            Google's Privacy & Terms
          </a>
          .
        </li>
      </ul>
      <p>
        By using the Application, you consent to the processing of data about
        you by these third-party providers in the manner and for the purposes
        set out in their respective privacy policies.
      </p>

      <h2>3. Log Data</h2>
      <p>
        We want to inform you that whenever you use our Service, in a case of an
        error in the app we collect data and information (through third-party
        products) on your phone called Log Data. This Log Data may include
        information such as your device Internet Protocol (“IP”) address, device
        name, operating system version, the configuration of the app when
        utilizing our Service, the time and date of your use of the Service, and
        other statistics.
      </p>

      <h2>4. Cookies and Device Identifiers</h2>
      <p>
        Cookies are files with a small amount of data that are commonly used as
        anonymous unique identifiers. This Service does not use these “cookies”
        explicitly. However, the app may use third-party code and libraries
        (like AdMob and Analytics) that use cookies or device identifiers (such
        as IDFA) to collect information and improve their services. You have the
        option to accept or refuse these identifiers through your iOS device
        settings.
      </p>

      <h2>5. Service Providers</h2>
      <p>
        We may employ third-party companies and individuals due to the following
        reasons: to facilitate our Service, to provide the Service on our
        behalf, to perform Service-related services, or to assist us in
        analyzing how our Service is used. These third parties have access to
        your Personal Information to perform the tasks assigned to them on our
        behalf. However, they are obligated not to disclose or use the
        information for any other purpose.
      </p>

      <h2>6. Data Security</h2>
      <p>
        We implement commercially reasonable security measures to protect the
        limited data our application collects. Since our app primarily provides
        external reward links and does not require you to create an account or
        provide sensitive personal information (such as your name, email, or
        passwords), the risk of sensitive data exposure is extremely low.
        However, please remember that no method of transmission over the
        internet or electronic storage is 100% secure, and we cannot guarantee
        its absolute security.
      </p>

      <h2>7. Children’s Privacy</h2>
      <p>
        These Services do not address anyone under the age of 13. We do not
        knowingly collect personally identifiable information from children
        under 13 years of age. In the case we discover that a child under 13 has
        provided us with personal information, we immediately delete this from
        our servers.
      </p>

      <h2>8. Data Deletion and Your Rights (GDPR & CCPA)</h2>
      <p>
        Depending on your location, you may have the right to access, update, or
        delete the personal information we have on you. Because we do not
        require user accounts, most data collected is anonymous or linked to
        device identifiers. If you wish to request the deletion of any
        advertising or analytics data associated with your device, please
        contact us. You may also opt-out of personalized tracking directly
        through your iOS device settings (App Tracking Transparency).
      </p>

      <h2>9. Links to Other Sites</h2>
      <p>
        This Service may contain links to other sites. If you click on a
        third-party link, you will be directed to that site. Note that these
        external sites are not operated by us. Therefore, we strongly advise you
        to review the Privacy Policy of these websites. We have no control over
        and assume no responsibility for the content, privacy policies, or
        practices of any third-party sites or services.
      </p>

      <h2>10. Changes to This Privacy Policy</h2>
      <p>
        We may update our Privacy Policy from time to time. Thus, you are
        advised to review this page periodically for any changes. We will notify
        you of any changes by posting the new Privacy Policy on this page. This
        policy is effective as of June 08, 2026.
      </p>

      <h2>11. Contact Us</h2>
      <p>
        If you have any questions or suggestions about our Privacy Policy, do
        not hesitate to contact us at:
      </p>
      <ContactSpin isMonopoly={true} />
    </div>
  );
};

export default CrazyFoxPrivacyPolicy;
